import api from "@/api";

const url = "/cases";
const subpart = "requests";

const indexUrl = "/case-requests";

export async function getIndex(params) {
	try {
			const response = await api.get(indexUrl, { params });
	
			if (!response || !response.data) {
				throw new Error("Invalid response structure");
			}
	
			return response.data;
		} catch (error) {
			console.error("Error fetching index data:", error?.response?.data || error.message);
			return { data: [], pagination: {} }; // Fallback to prevent app crashes
		}
}
export async function getAllRequest(params) {
	const response = await api.get(`${indexUrl}/getAllRequest`, params);
}
export async function getOpen(params) {
	try {
		const updatedParams = {
			...params,
			status: ["InProcess", "Submitted", "Returned", "Re-work"],
		};

		const response = await api.get(indexUrl, { params: updatedParams });

		if (!response || !response.data) {
			throw new Error("Invalid response structure");
		}

		return response.data;
	} catch (error) {
		console.error("Error fetching open cases:", error?.response?.data || error.message);
		return { data: [], pagination: {} }; // Fallback to prevent breaking the app
	}
}


export async function get(params) {
	const response = await api.get(`${url}/${params.case_id}/${subpart}/${params.id}`);
	return response.data.data;
}
export async function existingRequest(params) {
	const response = await api.get(`${url}/${params.case_id}/existingRequest/${params.id}`, {
		params: {
		  client_id: params.client_id, // Pass client_id as a query parameter
		}
	});
	return response.data;
}
export async function getRequestbyIDs(params) {
	// const response = await api.get(`${url}/${params.case_id}/getRequestbyIDs/${params.id}`);

	const response = await api.get(`${url}/getRequestbyIDs`, {
		params: {
			id: params.id, // Pass id array as query param
			case_id: params.case_id // Pass case_id array as query param
		}
	});
	return response.data;
}

export async function save(params) {
	if (params.id) {
		const response = await api.patch(`${url}/${params.case_id}/${subpart}/${params.id}`, params);
		return response.data.data;
	} else {
		// api/cases/1182/requests
		const response = await api.post(`${url}/${params.case_id}/${subpart}`, params);
		return response.data.data;
	}
}

export async function create(params) {
	const response = await api.post(`${url}/${params.case_id}/${subpart}`, params);
	return response.data.data;
}

export async function update(params) {
	const response = await api.patch(`${url}/${params.case_id}/${subpart}/${params.id}`, params);
	return response.data.data;
}

export async function destroy(params) {
	const response = await api.delete(`${url}/${params.case_id}/${subpart}/${params.id}`, {
		_method: "DELETE",
	});
	return response.data;
}

export async function close(params) {
	const response = await api.post(`${url}/${params.case_id}/${subpart}/${params.id}/close`, params);
	return response.data.data;
}

export async function reopen(params) {
	const response = await api.post(`${url}/${params.case_id}/${subpart}/${params.id}/reopen`, params);
	return response.data.data;
}

export async function setUtc(params) {
	const response = await api.post(`${url}/${params.case_id}/${subpart}/${params.id}/utc`, {
		unable_to_complete: params.unable_to_complete,
	});
	return response.data.data;
}
export async function setMarkUrgent(params) {
	const response = await api.post(`${url}/${params.case_id}/${subpart}/${params.id}/markUrgent`, {
		urgent: params.urgent,
	});
	return response.data.data;
}

export async function assign(params) {
	const response = await api.post(`${url}/${params.case_id}/${subpart}/${params.id}/assign`, {
		user_id: params.user_id,
	});

	return response.data.data;
}

export async function updateResponseReceived(requestId) {
    try {
        const response = await api.post(`/client/api/case-requests/update-response-received/${requestId}`, { id: requestId });
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.message || error.message);
    }
}